import CoreChartAccountAutomatedMapping from "components/CoreAutomatedMapping"
import React from "react"

const ChartAccountAutomatedMappingScene = (): JSX.Element => {
  return <CoreChartAccountAutomatedMapping />
}

export default ChartAccountAutomatedMappingScene
